import React from "react";
import PropTypes from "prop-types";
import { Line } from "rc-progress";
import { bm, be } from "../../../utils/bliss";

import "./progressBarLanding.css";

const MODULE_NAME = "ProgressBarLanding";

const ProgressBarLanding = ({ progress }) => (
  <div className={bm(MODULE_NAME)}>
    <div className={be(MODULE_NAME, "percentage", null)}>{progress}%</div>
    <Line
      percent={progress > 100 ? 100 : progress}
      strokeColor="#E73F2D"
      strokeWidth="2"
      text={`${progress}%`}
      trailColor="#D9DAD7"
      trailWidth="2"
    />
  </div>
);

ProgressBarLanding.defaultProps = {
  progress: 0
};

ProgressBarLanding.propTypes = {
  progress: PropTypes.number
};

export default ProgressBarLanding;
